import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Represents the view for other expenses.
 */
export default class otherExpensesView extends JetView {
    /**
     * Configures the view layout and data.
     * @returns {Object} The layout configuration.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting
        const vthis = this; // Reference to the current instance
        const cur_id = this.getParam('CloseBoxId', true); // Get current CloseBoxId parameter
        const data = []; // Initial data array
        let totalBets = 0; // Total bets initialization
        totalBets = data // Calculate total bets
            .map((item) => item.Bets)
            .reduce((prev, curr) => prev + curr, 0);
        let totalPrize = 0; // Total prize initialization
        totalPrize = data // Calculate total prize
            .map((item) => item.Prize)
            .reduce((prev, curr) => prev + curr, 0);

        // Configuration for the first data table
        var gridProduct1 = {
            rows: [
                {
                    view: 'datatable',
                    id: 'gridProduct1',
                    css: 'webix_header_border webix_data_border',
                    autoheight: true,
                    scroll: false,
                    columns: [
                        {
                            id: 'Product',
                            header: {
                                text: _('Productos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            css: { background: '#f3f3f3;' },
                            width: 300,
                        },
                        {
                            id: 'User',
                            header: {
                                text: _('Usuario que lo creo'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            width: 200,
                        },
                        {
                            id: 'Bets',
                            header: {
                                text: _('Ingresos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            minWidth: 150,
                            fillspace: true,
                        },
                        {
                            id: 'Prize',
                            header: {
                                text: _('Egresos'), // Localized header
                                css: { 'text-align': 'center' },
                            },
                            minWidth: 150,
                            fillspace: true,
                        },
                    ],
                    data: data, // Initial data for the table
                },
            ],
        };

        /**
         * Updates the total bets from both grids.
         * @returns {number} The total bets.
         */
        function updateSummBets() {
            var summ = 0;
            $$('gridProduct1').data.each(function (row) {
                summ += row.Bets * 1 || 0; // Sum bets from gridProduct1
            });
            $$('gridProduct2').data.each(function (row) {
                summ += row.Bets * 1 || 0; // Sum bets from gridProduct2
            });
            return summ; // Return total bets
        }

        /**
         * Updates the total prizes from both grids.
         * @returns {number} The total prizes.
         */
        function updateSummPrize() {
            var summ = 0;
            $$('gridProduct1').data.each(function (row) {
                summ += row.Prize * 1 || 0; // Sum prizes from gridProduct1
            });
            $$('gridProduct2').data.each(function (row) {
                summ += row.Prize * 1 || 0; // Sum prizes from gridProduct2
            });
            return summ; // Return total prizes
        }

        const data2 = [
            // Initial data for the second grid
            {
                id: '1',
                Product: 'Inbet',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '2',
                Product: 'Producto 2',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '3',
                Product: 'Producto 3',
                Bets: 0,
                Prize: 0,
            },
            {
                id: '4',
                Product: 'Producto 4',
                Bets: 0,
                Prize: 0,
            },
        ];

        /**
         * Checks if a value is not empty.
         * @param {any} value - The value to check.
         * @returns {boolean} True if not empty, otherwise false.
         */
        function notEmpty(value) {
            return value != '';
        }

        /**
         * Checks if a value is a positive integer.
         * @param {number} value - The value to check.
         * @returns {boolean} True if positive integer, otherwise false.
         */
        function positiveInteger(value) {
            return value >= 0;
        }

        // Configuration for the second data table
        var gridProduct2 = {
            rows: [
                {
                    view: 'datatable',
                    autoConfig: true,
                    id: 'gridProduct2',
                    editable: true,
                    css: 'webix_header_border webix_data_border',
                    columns: [
                        { id: 'Product', width: 300 },
                        { id: 'User', width: 200 },
                        {
                            id: 'Bets',
                            editor: 'text',
                            minWidth: 150,
                            fillspace: true,
                        },
                        {
                            id: 'Prize',
                            editor: 'text',
                            minWidth: 150,
                            fillspace: true,
                        },
                    ],
                    header: false,
                    autoheight: true,
                    rules: {
                        Bets: positiveInteger, // Validation rule for Bets
                        Prize: positiveInteger, // Validation rule for Prize
                    },
                    ready: function () {
                        this.validate(); // Validate on ready
                    },
                },
            ],
        };

        // Event listener for updating total bets
        this.on(this.app, 'updateSummBets', (sum) => {
            var total = totalBets + updateSummBets(); // Calculate total bets
            vthis.app.callEvent('totalIncomesProducts:sum', [{ total }]); // Trigger event with total
        });

        // Event listener for updating total prizes
        this.on(this.app, 'updateSummPrize', (sum) => {
            var total = totalPrize + updateSummPrize(); // Calculate total prizes
            vthis.app.callEvent('totalExpensesProducts:sum', [{ total }]); // Trigger event with total
        });

        return {
            rows: [gridProduct1, gridProduct2], // Return the layout with both grids
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        var vthis = this; // Reference to the current instance
        const cur_id = this.getParam('CloseBoxId', true); // Get current CloseBoxId parameter

        // Attach event for data store updates in gridProduct2
        $$('gridProduct2').data.attachEvent('onStoreUpdated', function (id, obj, mode) {
            if (mode == 'add' || mode == 'update' || mode == 'delete') {
                if ($$('gridProduct2').validate()) {
                    // Validate data
                    vthis.app.callEvent('updateSummBets', [{}]); // Update total bets
                    vthis.app.callEvent('updateSummPrize', [{}]); // Update total prizes
                    vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
                }
            }
        });

        // Delay execution of events to allow for data processing
        webix.delay(
            function () {
                vthis.app.callEvent('updateSummBets', [{}]); // Update total bets
                vthis.app.callEvent('updateSummPrize', [{}]); // Update total prizes
                vthis.app.callEvent('productsObject', [{}]); // Trigger products object event
            },
            '',
            '',
            200,
        );

        // AJAX request to fetch products by BetShop
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(
                devConfig.geturlApi() + 'Accounting/GetProductsByBetShop',
                '{"BetShopId":' + profile.AgentId + ',"State":"A", "CloseBoxId":"' + cur_id + '"}',
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message on failure
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var resp = JSON.parse(text); // Parse response
                        for (var i = 0; i < resp.Data.length; i++) {
                            resp.Data[i].id = resp.Data[i].Id; // Map Id to id
                            resp.Data[i].Product = resp.Data[i].Product; // Map Product
                            resp.Data[i].Bets = resp.Data[i].Bets; // Map Bets
                            resp.Data[i].Prize = resp.Data[i].Prize; // Map Prize
                            delete resp.Data[i].Id; // Remove unnecessary fields
                            delete resp.Data[i].State;
                            delete resp.Data[i].Name;
                            delete resp.Data[i].Account;
                            delete resp.Data[i].Provider;
                            var val1 = resp.Data[i].Bets; // Store Bets value
                            var val2 = resp.Data[i].Prize; // Store Prize value
                            vthis.app.callEvent('totalIncomesProducts:sum', [
                                { val1 }, // Trigger event for total incomes
                            ]);
                            vthis.app.callEvent('totalExpensesProducts:sum', [
                                { val2 }, // Trigger event for total expenses
                            ]);
                        }
                        console.log(resp.Data); // Log response data
                        $$('gridProduct2').define('data', resp.Data); // Define data for gridProduct2
                    },
                },
            );

        /**
         * Loads the product table based on the filter.
         * @param {Object} filter - The filter object.
         */
        function loadTable(filter) {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(
                    devConfig.geturlApi() + 'Accounting/GetProductsPlatformByBetShopToday',
                    '{"BetShopId":' +
                        profile.AgentId +
                        ',"State":"A", "IdCashier":"' +
                        filter.Id +
                        '", "CloseBoxId":"' +
                        cur_id +
                        '"}',
                    {
                        error: function (text, data, XmlHttpRequest) {
                            webix.message('Error! '); // Error message on failure
                        },
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response
                            $$('gridProduct1').clearAll(); // Clear existing data
                            $$('gridProduct1').define('data', resp.Data); // Define new data for gridProduct1
                            vthis.app.callEvent('updateSummBets', [{}]); // Update total bets
                            vthis.app.callEvent('updateSummPrize', [{}]); // Update total prizes
                        },
                    },
                );
        }

        loadTable({ Id: '' }); // Initial load of the table

        // Event listener for cashier view changes
        this.on(this.app, 'viewCashier', (filter) => {
            loadTable(filter); // Load table with new filter
        });
    }
}

// FILE DOCUMENTED
